<!--
  Excel'dan mahsulot import — har do'kon kartochkasining 3 nuqta menyusidan ochiladi.
  Oyna admin paneli bilan BIR XIL komponent; farqi faqat qaysi endpointga borishida
  va bu yerda do'kon oldindan qulflanganida.
-->
<app-product-import-dialog
  [(visible)]="importDialogOpen"
  [subtitle]="importStoreName()"
  [lockedStoreId]="importStoreId()"
  [currencyOptions]="currencySvc.currencyOptions()"
  [defaultCurrency]="currencySvc.defaultCode()"
  [previewFn]="importPreviewFn"
  [submitFn]="importSubmitFn"
  (imported)="onProductsImported()"
/>

<div class="space-y-8 relative">
  <!-- Header -->
  <div class="flex items-center justify-between">
    <div>
      <h1 class="text-3xl font-bold text-gray-900 dark:text-gray-100 italic">
        {{ 'STORES.TITLE' | translate }}
      </h1>
      <p class="text-gray-600 dark:text-gray-400 mt-2">{{ 'STORES.SUBTITLE' | translate }}</p>
    </div>
    <button
      (click)="openDialog()"
      class="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none disabled:pointer-events-none disabled:opacity-50 bg-green-600 text-white hover:bg-green-700 h-10 px-4 py-2 hover:cursor-pointer"
    >
      <lucide-icon [img]="Plus" class="w-4 h-4 mr-2"></lucide-icon>
      {{ 'STORES.ADD' | translate }}
    </button>
  </div>

  @if (isDialogOpen()) {
    <div class="fixed inset-0 z-50 flex items-end sm:items-center justify-center sm:p-4">
      <!-- eslint-disable-next-line -->
      <div class="absolute inset-0 bg-black/50" (click)="closeDialog()"></div>
      <div
        class="relative bg-white dark:bg-gray-900 rounded-t-2xl sm:rounded-xl shadow-lg w-full sm:max-w-lg flex flex-col overflow-hidden"
      >
        <div class="p-6 border-b border-gray-100 dark:border-gray-800 pb-4">
          <h2 class="text-lg font-semibold leading-none tracking-tight">
            {{
              isEditMode()
                ? ('STORES.FORM.EDIT_TITLE' | translate)
                : ('STORES.FORM.ADD_TITLE' | translate)
            }}
          </h2>
          <p class="text-sm text-gray-500 dark:text-gray-400 mt-1">
            {{
              isEditMode()
                ? ('STORES.FORM.EDIT_SUB' | translate)
                : ('STORES.FORM.ADD_SUB' | translate)
            }}
          </p>
        </div>

        @if (errorMessage()) {
          <div
            class="mx-6 mt-4 p-3 bg-red-50 dark:bg-red-900/20 text-red-600 rounded-lg text-sm flex items-center gap-2"
          >
            <lucide-icon [img]="AlertCircle" class="w-4 h-4"></lucide-icon>
            {{ errorMessage() }}
          </div>
        }

        <form (submit)="handleSubmit()" class="p-6 space-y-4">
          <div class="space-y-2">
            <label for="" class="text-sm font-medium leading-none font-semibold">{{
              'STORES.FORM.NAME' | translate
            }}</label>
            <input
              name="name"
              [(ngModel)]="formData.name"
              [placeholder]="'STORES.FORM.NAME_HINT' | translate"
              class="flex h-10 w-full rounded-md border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 px-3 py-2 text-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gray-950"
            />
          </div>
          <div class="space-y-2">
            <label for="" class="text-sm font-medium leading-none font-semibold">{{
              'STORES.FORM.ADDRESS' | translate
            }}</label>
            <input
              name="address"
              [(ngModel)]="formData.address"
              [placeholder]="'STORES.FORM.ADDRESS_HINT' | translate"
              class="flex h-10 w-full rounded-md border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 px-3 py-2 text-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gray-950"
            />
          </div>
          <!-- <div class="space-y-2">
            <label for="" class="text-sm font-medium leading-none font-semibold">{{
              'STORES.FORM.TYPE' | translate
            }}</label>
            <select
              name="storeTypeId"
              [(ngModel)]="formData.storeTypeId"
              class="flex h-10 w-full rounded-md border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 px-3 py-2 text-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gray-950"
            >
              <option [ngValue]="null">— {{ 'STORES.FORM.TYPE_NONE' | translate }} —</option>
              @for (st of storeTypes(); track st.id) {
                <option [ngValue]="st.id">{{ st.name }}</option>
              }
            </select>
            <p class="text-xs text-gray-400">{{ 'STORES.FORM.TYPE_HINT' | translate }}</p>
          </div> -->
          @if (isEditMode()) {
            <div class="flex items-center gap-2 py-2">
              <input
                type="checkbox"
                id="isActive"
                name="isActive"
                [(ngModel)]="formData.isActive"
                class="w-4 h-4 text-gray-900 border-gray-300 rounded"
              />
              <label for="isActive" class="text-sm font-medium text-gray-700 dark:text-gray-300">
                {{ 'STORES.FORM.STATUS' | translate }}
              </label>
            </div>
          }
          <div class="pt-2 flex justify-end items-center gap-2">
            <button
              type="button"
              (click)="closeDialog()"
              class="inline-flex items-center justify-center rounded-md text-sm font-medium transition-colors border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 hover:bg-gray-100 dark:hover:bg-gray-800 hover:text-gray-900 dark:text-gray-100 h-10 px-4 py-2 hover:cursor-pointer"
            >
              {{ 'STORES.FORM.CANCEL' | translate }}
            </button>
            <button
              type="submit"
              [disabled]="isLoading()"
              class="inline-flex items-center justify-center rounded-md text-sm font-medium transition-colors bg-gray-900 text-gray-50 dark:bg-gray-100 dark:text-gray-900 hover:bg-gray-900/90 h-10 px-4 py-2 hover:cursor-pointer disabled:opacity-50"
            >
              {{
                isEditMode()
                  ? ('STORES.FORM.UPDATE' | translate)
                  : ('STORES.FORM.CREATE' | translate)
              }}
            </button>
          </div>
        </form>
      </div>
    </div>
  }

  <!-- Bbox Map Dialog -->
  @if (bboxDialogOpen()) {
    <div class="fixed inset-0 z-50 flex items-center justify-center p-4">
      <!-- eslint-disable-next-line -->
      <div class="absolute inset-0 bg-black/60" (click)="closeBboxDialog()"></div>
      <div
        class="relative bg-white rounded-2xl shadow-2xl w-full max-w-3xl overflow-hidden flex flex-col"
      >
        <!-- Header -->
        <div class="px-5 py-4 border-b border-gray-100 flex items-center justify-between">
          <div>
            <h2 class="font-semibold text-gray-900 flex items-center gap-2">
              <lucide-icon [img]="Map" class="text-green-600 w-5 h-5" />
              {{ 'STORES.MAP.TITLE' | translate: { name: bboxStoreName() } }}
            </h2>
            <p class="text-xs text-gray-400 mt-0.5">{{ 'STORES.MAP.HINT' | translate }}</p>
          </div>
          <button (click)="closeBboxDialog()" class="text-gray-400 hover:text-gray-700 p-1">
            <lucide-icon [img]="X" class="w-5 h-5" />
          </button>
        </div>

        <!-- Toolbar -->
        <div
          class="px-5 py-2.5 border-b border-gray-100 flex items-center gap-3 bg-gray-50 flex-wrap"
        >
          <button
            (click)="flyToMyLocation(true)"
            [disabled]="locating()"
            class="flex items-center gap-1.5 text-sm text-green-600 hover:text-green-800 font-medium disabled:opacity-60"
          >
            <lucide-icon [img]="Navigation" class="w-4 h-4" />
            {{
              locating()
                ? ('STORES.MAP.LOCATING' | translate)
                : ('STORES.MAP.MY_LOCATION' | translate)
            }}
          </button>

          @if (bboxResult) {
            <div class="h-4 w-px bg-gray-300 hidden sm:block"></div>
            <div class="flex items-center gap-1">
              <span class="text-xs text-gray-500 mr-1">{{ 'STORES.MAP.SIZE' | translate }}</span>
              <button
                (click)="expandBbox(5)"
                class="flex items-center gap-0.5 text-xs px-2 py-1 rounded bg-white border border-gray-200 hover:bg-gray-50 font-medium"
              >
                <lucide-icon [img]="ZoomIn" class="w-3.5 h-3.5" /> +5m
              </button>
              <button
                (click)="expandBbox(20)"
                class="flex items-center gap-0.5 text-xs px-2 py-1 rounded bg-white border border-gray-200 hover:bg-gray-50 font-medium"
              >
                +20m
              </button>
              <button
                (click)="shrinkBbox(5)"
                class="flex items-center gap-0.5 text-xs px-2 py-1 rounded bg-white border border-gray-200 hover:bg-gray-50 font-medium"
              >
                <lucide-icon [img]="ZoomOut" class="w-3.5 h-3.5" /> -5m
              </button>
            </div>
          }

          @if (bboxResult) {
            <div
              class="ml-auto flex items-center gap-2 text-xs text-green-700 bg-green-50 rounded-lg px-3 py-1.5 font-mono"
            >
              <lucide-icon [img]="CheckCircle" class="w-3.5 h-3.5 shrink-0" />
              <span>{{ formatArea(bboxAreaM2()) }}</span>
            </div>
          }
        </div>

        <!-- Map -->
        <div id="bbox-map" style="height: 380px; width: 100%"></div>

        <!-- Footer -->
        <div
          class="px-5 py-3 border-t border-gray-100 flex items-center justify-between gap-3 bg-gray-50"
        >
          @if (!bboxResult) {
            <p class="text-sm text-amber-600 flex items-center gap-1.5">
              <span class="text-base">📐</span>
              {{ 'STORES.MAP.DRAW_HINT' | translate }}
            </p>
          } @else {
            <p class="text-sm text-gray-500">{{ 'STORES.MAP.EDIT_HINT' | translate }}</p>
          }
          <div class="flex gap-2 shrink-0">
            <button
              (click)="closeBboxDialog()"
              class="px-4 py-2 text-sm border border-gray-200 rounded-lg hover:bg-gray-50"
            >
              {{ 'STORES.MAP.CANCEL' | translate }}
            </button>
            <button
              (click)="saveBbox()"
              [disabled]="bboxSaving() || !bboxResult"
              class="px-4 py-2 text-sm bg-green-600 hover:bg-green-700 text-white rounded-lg disabled:opacity-50 flex items-center gap-2"
            >
              <lucide-icon [img]="CheckCircle" class="w-4 h-4" />
              {{
                bboxSaving() ? ('STORES.MAP.SAVING' | translate) : ('STORES.MAP.SAVE' | translate)
              }}
            </button>
          </div>
        </div>
      </div>
    </div>
  }

  @if (isLoading() && storeList().length === 0) {
    <div class="flex flex-col items-center justify-center py-24 space-y-4">
      <div
        class="w-10 h-10 border-4 border-gray-200 border-t-gray-900 rounded-full animate-spin"
      ></div>
      <p class="text-gray-500">{{ 'STORES.LOADING' | translate }}</p>
    </div>
  } @else {
    <!-- Store Grid -->
    <div class="grid gap-6 md:grid-cols-2 xl:grid-cols-3">
      @for (store of storeList(); track store.storeId) {
        <div
          class="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 text-gray-950 dark:text-gray-100 shadow-sm relative overflow-visible"
        >
          <div class="p-6 pb-3">
            <div class="flex items-start justify-between relative">
              <div class="flex-1">
                <h3 class="font-semibold leading-none tracking-tight text-xl">
                  {{ store.storeName }}
                </h3>
                <p class="text-sm text-gray-500 dark:text-gray-400 flex items-center gap-1 mt-2">
                  <lucide-icon [img]="MapPin" class="w-4 h-4"></lucide-icon>
                  {{ store.address }}
                </p>
              </div>

              <div class="relative inline-block text-left group">
                <button
                  class="inline-flex items-center justify-center rounded-md text-sm font-medium transition-colors hover:bg-gray-100 dark:hover:bg-gray-800 hover:text-gray-900 dark:text-gray-100 h-9 w-9"
                >
                  <lucide-icon [img]="MoreVertical" class="w-4 h-4"></lucide-icon>
                </button>
                <div
                  class="hidden group-hover:block absolute right-0 z-10 w-44 origin-top-right rounded-md bg-white dark:bg-gray-900 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none border border-gray-100 dark:border-gray-800"
                >
                  <div class="py-1">
                    <button
                      (click)="viewAnalytics(store.storeId)"
                      class="w-full text-left flex px-4 py-2 text-sm hover:bg-gray-100 dark:hover:bg-gray-800 text-gray-700 dark:text-gray-300"
                    >
                      <lucide-icon [img]="Eye" class="w-4 h-4 mr-2"></lucide-icon>
                      {{ 'STORES.MENU.VIEW' | translate }}
                    </button>
                    <button
                      (click)="openDialog(store)"
                      class="w-full text-left flex px-4 py-2 text-sm hover:bg-gray-100 dark:hover:bg-gray-800 text-gray-700 dark:text-gray-300"
                    >
                      <lucide-icon [img]="Edit" class="w-4 h-4 mr-2"></lucide-icon>
                      {{ 'STORES.MENU.EDIT' | translate }}
                    </button>
                    <button
                      (click)="openImportDialog(store)"
                      class="w-full text-left flex px-4 py-2 text-sm hover:bg-gray-100 dark:hover:bg-gray-800 text-gray-700 dark:text-gray-300"
                    >
                      <lucide-icon [img]="Upload" class="w-4 h-4 mr-2"></lucide-icon>
                      {{ 'STORES.MENU.IMPORT' | translate }}
                    </button>
                    <button
                      (click)="openBboxDialog(store)"
                      class="w-full text-left flex px-4 py-2 text-sm hover:bg-green-50 dark:hover:bg-green-900/20 text-green-600"
                    >
                      <lucide-icon [img]="Map" class="w-4 h-4 mr-2"></lucide-icon>
                      {{ 'STORES.MENU.MAP' | translate }}
                    </button>
                    <!-- <button
                      (click)="handleDelete(store)"
                      class="w-full text-left flex px-4 py-2 text-sm hover:bg-red-50 dark:hover:bg-red-900/20 text-red-600"
                    >
                      <lucide-icon [img]="Trash2" class="w-4 h-4 mr-2"></lucide-icon>
                      {{ 'STORES.MENU.DELETE' | translate }}
                    </button> -->
                  </div>
                </div>
              </div>
            </div>

            <div class="flex items-center gap-2 mt-3">
              <div
                class="inline-flex items-center border-transparent border font-semibold px-2.5 py-0.5 text-xs rounded-full w-fit"
                [class]="
                  store.isActive
                    ? 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400'
                    : 'bg-gray-100 text-gray-700 dark:bg-gray-700 dark:text-gray-400'
                "
              >
                {{
                  store.isActive ? ('COMMON.ACTIVE' | translate) : ('COMMON.INACTIVE' | translate)
                }}
              </div>
              @if (store.lowStockItems > 0) {
                <div
                  class="inline-flex items-center border font-semibold px-2.5 py-0.5 text-xs rounded-full bg-amber-100 text-amber-700 border-amber-200"
                >
                  {{ store.lowStockItems }} {{ 'STORES.LOW_STOCK' | translate }}
                </div>
              }
            </div>
          </div>

          <div class="p-6 pt-0 space-y-4">
            <div
              class="flex items-center justify-between p-3 bg-green-50 dark:bg-green-900/20 rounded-lg"
            >
              <div class="flex items-center gap-2">
                <lucide-icon [img]="DollarSign" class="w-5 h-5 text-green-600"></lucide-icon>
                <span class="text-sm text-gray-600 dark:text-gray-400 font-semibold">{{
                  'STORES.REVENUE' | translate
                }}</span>
              </div>
              <!--
                Tushum HAR valyutada alohida (I11). Jamlangan bitta son yo'q —
                dollar bilan so'mni qo'shib bo'lmaydi.
              -->
              <span class="font-semibold text-gray-900 dark:text-gray-100 text-right">
                @for (r of store.revenueByCurrency; track r.currency) {
                  <span class="block">{{ r.revenue | money: r.currency }}</span>
                } @empty {
                  <span class="block">{{ 0 | money: store.currency }}</span>
                }
              </span>
            </div>
            <div
              class="flex items-center justify-between p-3 bg-green-50 dark:bg-green-900/20 rounded-lg"
            >
              <div class="flex items-center gap-2">
                <lucide-icon [img]="ShoppingCart" class="w-5 h-5 text-green-600"></lucide-icon>
                <span class="text-sm text-gray-600 dark:text-gray-400 font-semibold">{{
                  'STORES.ORDERS' | translate
                }}</span>
              </div>
              <span class="font-semibold text-gray-900 dark:text-gray-100">
                {{ store.totalOrders }}
              </span>
            </div>
            <button
              (click)="viewAnalytics(store.storeId)"
              class="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium transition-all border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 hover:bg-gray-50 dark:hover:bg-gray-800 hover:text-gray-900 dark:text-gray-100 h-9 px-4 py-2 w-full active:scale-95 cursor-pointer"
            >
              {{ 'STORES.ANALYTICS' | translate }}
            </button>
            <button
              (click)="navigateToPos(store.storeId)"
              class="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-all bg-green-600 hover:bg-green-700 text-white h-9 px-4 py-2 w-full active:scale-95 cursor-pointer"
            >
              <lucide-icon [img]="Monitor" class="w-4 h-4"></lucide-icon>
              {{ 'STORES.POS' | translate }}
            </button>
          </div>
        </div>
      }
    </div>

    <!-- Store Performance Summary -->
    @if (storeList().length > 0) {
      <div
        class="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 text-gray-950 dark:text-gray-100 shadow-sm mt-8"
      >
        <div class="flex flex-col space-y-1.5 p-6 border-b border-gray-100 dark:border-gray-800">
          <h3 class="font-semibold leading-none tracking-tight text-lg">
            {{ 'STORES.PERFORMANCE' | translate }}
          </h3>
          <p class="text-sm text-gray-500 dark:text-gray-400">
            {{ 'STORES.PERFORMANCE_SUB' | translate }}
          </p>
        </div>
        <div class="p-0 overflow-hidden">
          <div class="overflow-x-auto w-full">
            <table class="w-full text-sm">
              <thead>
                <tr class="border-b bg-gray-50/50 dark:bg-gray-900/50">
                  <th
                    class="h-12 px-4 text-left align-middle font-semibold text-gray-500 dark:text-gray-400"
                  >
                    {{ 'STORES.TABLE.NAME' | translate }}
                  </th>
                  <th
                    class="h-12 px-4 text-left align-middle font-semibold text-gray-500 dark:text-gray-400"
                  >
                    {{ 'STORES.TABLE.ADDRESS' | translate }}
                  </th>
                  <th
                    class="h-12 px-4 text-right align-middle font-semibold text-gray-500 dark:text-gray-400"
                  >
                    {{ 'STORES.TABLE.REVENUE' | translate }}
                  </th>
                  <th
                    class="h-12 px-4 text-right align-middle font-semibold text-gray-500 dark:text-gray-400"
                  >
                    {{ 'STORES.TABLE.ORDERS' | translate }}
                  </th>
                  <th
                    class="h-12 px-4 text-right align-middle font-semibold text-gray-500 dark:text-gray-400"
                  >
                    {{ 'STORES.TABLE.LOW_STOCK' | translate }}
                  </th>
                </tr>
              </thead>
              <tbody>
                @for (store of storeList(); track store.storeId) {
                  <tr class="border-b transition-colors hover:bg-gray-50 dark:hover:bg-gray-800/50">
                    <td class="p-4 align-middle font-bold">{{ store.storeName }}</td>
                    <td class="p-4 align-middle text-gray-600 dark:text-gray-400">
                      {{ store.address }}
                    </td>
                    <td
                      class="p-4 align-middle text-right font-medium text-emerald-600 dark:text-emerald-400"
                    >
                      @for (r of store.revenueByCurrency; track r.currency) {
                        <div>{{ r.revenue | money: r.currency }}</div>
                      } @empty {
                        <div>{{ 0 | money: store.currency }}</div>
                      }
                    </td>
                    <td class="p-4 align-middle text-right font-semibold">
                      {{ store.totalOrders }}
                    </td>
                    <td class="p-4 align-middle text-right">
                      <span
                        [class.text-amber-600]="store.lowStockItems > 0"
                        [class.text-emerald-500]="store.lowStockItems === 0"
                      >
                        {{ store.lowStockItems }}
                      </span>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    }
  }
</div>

<p-confirmdialog />
